<div class="progress-container">
  <div class="progress-steps">
    <button 
      [class.prev-enabled]="isPrevButtonEnabled()" 
      [class.prev-disabled]="!isPrevButtonEnabled()"
      (click)="navigateToPrevStep()"
      [disabled]="!isPrevButtonEnabled()"
      style="justify-content: center; border: 0px; background-color: white;">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="m15 18-6-6 6-6"></path>
      </svg>
    </button>
    <div class="step" 
         *ngFor="let step of steps; let i = index"
         [ngClass]="getStepClass(step)"
         (click)="navigateToStep(step)"
         (keydown)="navigateToStep(step)"
         [class.clickable]="isStepClickable(step)">
      <div class="step-circle" [class.disabled]="getStepClass(step).disabled">
        <ng-container *ngIf="step.completed">{{ i + 1 }}</ng-container>
        <ng-container *ngIf="!step.completed">{{ i + 1 }}</ng-container>
      </div>
      <div class="step-label">{{ step.label }}</div>
    </div>
    <app-button 
      size="medium" 
      buttonType="primary"
      (click)="isNextButtonEnabled() && (getNextButtonLabel() === 'Submit Report' ? openFinalSubmission() : navigateToNextStep())"
      (keydown)="isNextButtonEnabled() && (getNextButtonLabel() === 'Submit Report' ? openFinalSubmission() : navigateToNextStep())"
      [disabled]="!isNextButtonEnabled()">
      {{ getNextButtonLabel() }}
    </app-button>
  </div>
</div>